import React from "react";
import Image from "next/image";
import { useTranslations } from '../../locales/useTranslations';

const KarriereBenefits = () => {
  const { t } = useTranslations();

  const benefits = [
    t('career_benefits_advantages_flexible'),
    t('career_benefits_advantages_education'),
    t('career_benefits_advantages_projects'),
    t('career_benefits_advantages_environment'),
  ];

  return (
    <div className="about-area pt-70 karriere-benefits">
      <div className="container">
        <div className="section-title text-left">
          <span className="sub-title karriere-benefits__badge">
            {t('career_benefits_subtitle')}
          </span>
          <h2 className="karriere-benefits__title">
            {t('career_benefits_title')}
          </h2>
        </div>
      </div>

      <div className="container">
        <div className="about-inner-area">
          <div className="row">
            <div className="col-lg-6 col-md-12">
              <div className="about-inner-image karriere-benefits__image-wrapper">
                <Image
                  src="/images/karriere/team.webp"
                  alt="simplify data - Team"
                  width={1600}
                  height={800}
                  className="karriere-benefits__image"
                />
              </div>
            </div>

            <div className="col-lg-6 col-md-12">
              <div className="about-inner-content">
                <div className="content">
                  <h4 className="karriere-benefits__advantages-title">
                    {t('career_benefits_advantages_title')}
                  </h4>
                  <ul className="karriere-benefits__list">
                    {benefits.map((benefit, index) => (
                      <li key={index} className="karriere-benefits__list-item">
                        <i className="bx bx-check karriere-benefits__check-icon" />
                        <span className="karriere-benefits__list-text">
                          {benefit}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="pt-35">
            <div className="karriere-benefits__description-box">
              <p className="karriere-benefits__description-text">
                {t('career_benefits_description')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KarriereBenefits;
